import { useSearchParams } from 'react-router-dom';

// Reads the ?platform= query param ('shopify' | 'woocommerce' | '').
// Used to scope the Boutiques sub-sections (Produits, Synchro, Snippets, Tutoriels)
// to a single e-commerce platform.
export function usePlatform() {
  const [params] = useSearchParams();
  const platform = params.get('platform') || '';
  const isWoo = platform === 'woocommerce';
  const matchStore = (s) =>
    !platform || (isWoo ? s.platform === 'woocommerce' : s.platform !== 'woocommerce');
  const label = isWoo ? 'WordPress / WooCommerce' : platform === 'shopify' ? 'Shopify' : '';
  return { platform, isWoo, matchStore, label };
}
